import { ReactNode } from 'react';
import { GetStreamBySlug_getStreamBySlug_overlayConfig_liveMatchState } from 'api/agora/types/GetStreamBySlug';
import ScoreboardOverlay from './ScoreboardOverlay';
import { getScoreboardOverlayProps } from './getScoreboardOverlayProps';
import { isScoreboardTemplate } from './fightCardHelpers';

export const buildViewerScoreboardNode = ({
  templateId,
  sponsorLogoKey,
  liveMatchState,
}: {
  templateId?: string | null;
  sponsorLogoKey?: string | null;
  liveMatchState?: GetStreamBySlug_getStreamBySlug_overlayConfig_liveMatchState | null;
}): ReactNode | undefined => {
  if (!isScoreboardTemplate(templateId)) {
    return undefined;
  }
  const scoreboardProps = getScoreboardOverlayProps({ liveMatchState });
  return scoreboardProps ? (
    <ScoreboardOverlay
      {...scoreboardProps}
      sponsorLogoKey={sponsorLogoKey}
      templateId={templateId}
    />
  ) : undefined;
};
